import React, { useMemo, forwardRef } from 'react'

import { DataTable as BaseDataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'

import { getMessage } from '../../util/IntlMessages'

// TODO: This component needs to be updated and rewritten.
const DataTable = forwardRef(({ itemsList, filters, columns, emptyMessage }, ref) => {
  const getTextColor = ({ active }) => {
    return active === false ? 'darkgray' : 'black'
  }

  const dataTableColumns = useMemo(
    () =>
      columns.map((column) => {
        const columnProps = {
          header: column.header,
          field: column.field,
          filterField: column.filterField,
          showFilterMenu: false,
          filterMenuStyle: { width: column.width },
          style: {
            minWidth: column.width,
            maxWidth: column.header === 'Editar' ? '5%' : 'auto'
          },
          body:
            column.body || ((rowData) => <span style={{ color: getTextColor(rowData) }}>{rowData[column.field]}</span>),
          filter: column.header !== 'Editar' && column.header !== 'Focal',
          responsive: column.responsive
        }

        return <Column key={column.field || 'actions'} {...columnProps} />
      }),
    [columns]
  )

  const filterFields = useMemo(() => columns.filter(({ field }) => Boolean(field)).map(({ field }) => field), [columns])

  return (
    <BaseDataTable
      ref={ref}
      value={itemsList}
      first={0}
      paginator
      rows={10}
      rowsPerPageOptions={[5, 10, 25, 50]}
      dataKey="id"
      filters={filters}
      scrollable
      scrollHeight="70vh"
      filterDisplay="row"
      responsiveLayout="scroll"
      globalFilterFields={filterFields}
      emptyMessage={getMessage(emptyMessage)}
      size="small"
      className="p-datatable-scrollable"
    >
      {dataTableColumns}
    </BaseDataTable>
  )
})

export default DataTable
